import React from 'react'
import formImg from './images/wpFormImg.webp';

const WhatsAppForms = () => {
  return (
    <section className="py-4 position-relative"
      style={{
        overflow: 'hidden',
        background: `
          linear-gradient(to bottom, rgba(255,255,255,0) 78%, rgba(255,255,255,1) 100%),
          radial-gradient(900px 600px at 0% 0%, rgba(204, 233, 254, 0.35) 0%, rgba(191,228,255,0) 60%),
          radial-gradient(900px 600px at 100% 0%, rgba(215, 255, 238, 0.28) 0%, rgba(192,252,226,0) 60%),
          linear-gradient(135deg, #f0f5ffff 0%, #EFFFF7 100%)
        `,
      }}
    >
      <div
        className="px-5 x-xxl-5 px-6 mx-auto position-relative"
        style={{
          maxWidth: '88%',
          zIndex: 1,
          marginTop: 10
        }}
      >
        {/* Row left + image right */}
        <div className="wa-forms-row">
          {/* Left: Heading */}
          <div className="wa-forms-copy">
            <h2
              style={{
                marginTop: '6rem',
                lineHeight: 1.1,
                letterSpacing: "-0.02em",
                color: "#242121ff",
                fontWeight: 700,
                fontSize: "3.6rem",
                fontFamily: "Inter",
              }}
            >
              Collect data seamlessly
              <br />
              with
              <span style={{ color: '#1DB954' }}>{' '}WhatsApp</span>{' '}Forms
            </h2>

            <p
              className="mt-2"
              style={{
                color: "#413e3eff",
                fontSize: "1.1rem",
                fontFamily: "Poppins",
                fontWeight: 300,
                maxWidth: 780,
                lineHeight: 1.3,
              }}
            >
              Enhance user engagement with forms that open directly within WhatsApp-eliminating the need for external browsers.
              Capture leads, qualify users, book orders and more using WhatsApp forms
            </p>

            {/* CTAs buttons */}
            <div className="wa-cta">
              <button type="button" className="wa-btn wa-btn-primary">
                Start for FREE <span className="wa-arrow">→</span>
              </button>
              <button type="button" className="wa-btn wa-btn-secondary">
                Talk to Sales
              </button>
            </div>
          </div>

          {/* Right image*/}
          <div className="wa-forms-visual">
            <img
              src={formImg}
              alt="WhatsApp Forms visual"
              style={{
                width: '100%',
                maxWidth: 700,
                height: 'auto',
                display: 'block'
              }}
            />
          </div>
        </div>
      </div>

      {/* styles */}
      <style>{`
        .wa-forms-row{
          display:flex;
          align-items:center;
          justify-content:space-between;
          gap:48px;
        }
        .wa-forms-copy{ flex:1; }
        .wa-forms-visual{ flex:1; text-align:right; }

        .wa-cta{
          margin-top: 18px;
          display:flex;
          align-items:center;
          gap:14px;
        }
        .wa-btn{
          position:relative;
          display:inline-flex;
          align-items:center;
          gap:10px;
          padding:12px 18px;
          border-radius:12px;
          font-family:Poppins, system-ui, -apple-system, Segoe UI, Roboto, Inter, sans-serif;
          font-weight:600;
          line-height:1;
          cursor:pointer;
          transition:transform .12s ease, box-shadow .12s ease, background .2s ease;
          user-select:none;
          white-space:nowrap;
        }
        .wa-btn:active{ transform:translateY(1px); }

        /* Primary (green) with mirror-shine hover */
        .wa-btn-primary{
          color:#fff;
          border:none;
          background: #054E91;
          overflow:hidden; 
        }
        .wa-btn-primary .wa-arrow{ font-weight:700; }
        .wa-btn-primary::after{
          content:"";
          position:absolute;
          top:-60%;
          left:-40%;
          width:40%;
          height:220%;
          pointer-events:none;
          background:linear-gradient(115deg,
                     rgba(255,255,255,0) 0%,
                     rgba(255,255,255,.6) 50%,
                     rgba(255,255,255,0) 100%);
          transform:skewX(-20deg);
          opacity:0;
        }
        .wa-btn-primary:hover{
        //   box-shadow: 0 14px 28px rgba(16, 185, 129, .3);
        }
        .wa-btn-primary:hover::after{
          animation: waShine 900ms cubic-bezier(.25,.8,.25,1) forwards;
          opacity:1;
        }
        @keyframes waShine{
          0%{ left:-60%; }
          100%{ left:120%; }
        }

        /* Secondary (outline) */
        .wa-btn-secondary{
          background:#fff;
          color:#1f2937;
          border:2px solid #e5e7eb;
        }
        .wa-btn-secondary:hover{
          background:#f8fafc;
          box-shadow: 0 6px 16px rgba(2,6,23,.06);
        }

        @media (max-width: 992px){
          .wa-forms-row{ flex-direction:column; gap:28px; }
          .wa-forms-visual{ text-align:center; }
        }
      `}</style>
    </section>
  )
}

export default WhatsAppForms
